// extracted by mini-css-extract-plugin
export default {"editableImage":"Gx10R","editableImageRemover":"o874i","editImageButton":"G9mV1","image":"Pm8W2","dropZone":"_N_3r","innerDropZone":"qjsFG","hidden":"i5JXD"};